<template>
  <div id="Head">
    <Login v-if="isLogin" @LoginOpen="openL($event)" />
    <div class="HTop">
      <img class="Logo" src="../assets/public/1.png" alt />
      <div class="nav">
        <img src="../assets/public/0.png" />
        <div class="nav_main">
          <ul>
            <li v-for="(item, index) in nav" v-bind:key="index">
              <!-- <a href="javascirpt:;" @click="to(index)" :class="{active:item.active}">{{item.name}}</a> -->
              <p @click="to(index)" :class="{ active: item.active }">
                {{ item.name }}
              </p>
              <span v-if="index != nav.length - 1">|</span>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="msg > 0" class="message" @click="toMsg(type)">{{ msg }}</div>
      <div class="login">
        <ul>
          <li>
            累计登录:
            <span>{{ logNum.totallogin }}次</span>
          </li>
          <li>
            今日登录:
            <span>{{ logNum.todaylogin }}次</span>
          </li>
        </ul>
        <div v-if="$uName">
          <div id="in" class="in" :class="msg > 0 ? 'sb' : ''" @click="toBack">
            <img src="../assets/public/2.png" />
            {{ $uName }}
          </div>
        </div>
        <div @click="outLogin()" style="color: red;" v-if="$uName">退出</div>
        <div style="color: red" v-if="!$uName">
          <img src="../assets/public/2.png" />您还未登录！
        </div>
        <div @click="openLogin()" v-if="!$uName">用户登录</div>
        <div @click="goRegister()" v-if="!$uName">用户注册</div>
      </div>
    </div>
    <div class="HImg">
      <img
        :src="
          $route.path == '/Classroom' || $route.path == '/CurriculumDetails'
            ? imgClass
            : imgBasic
        "
        :style="
          'height:' +
            ($route.path == '/Classroom' || $route.path == '/CurriculumDetails'
              ? '5.69rem'
              : '3rem')
        "
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Login from "../components/Login";
export default {
  name: "Head",
  data() {
    return {
      msg: "", //消息提醒
      isLogin: false,
      type: "",
      nav: [
        { name: "首页", to: "/Index", active: false },
        { name: "热点动态", to: "/Hotspot", active: false },
        { name: "通知公告", to: "/Notice", active: false },
        {
          name: "成果申报",
          to: "/Declare",
          active: false,
          text:
            "/Chart/decNotice/Surface/tableList/Report/Attachment/Preview/MessageCenter/Personage",
          // "/Attachment/Chart/decNotice/Surface/tableList/uploadReport/Preview"
        },
        {
          name: "成果库集",
          to: "/Library",
          active: false,
          text: "/LibraryDel",
        },
        {
          name: "创新课堂",
          to: "/Classroom",
          active: false,
          text: "/CurriculumDetails",
        },
        // { name: "项目转化", to: "/Translation/0", active: false },
        { name: "项目转化", to: "/Construction", active: false },
        { name: "联系我们", to: "/ContactUs", active: false },
      ],
      logNum: {
        todaylogin: 0,
        totallogin: 0,
        width: "",
      },
    };
  },
  inject: ["reload"],
  props: {},
  // watch: {
  //   "$route.query.up": "fetchData"
  // },
  created() {
    // console.log(sessionStorage);

    if (this.$route.path == "Index") {
      this.nav[0].active = true;
    } else {
      for (let i = 0; i < this.nav.length; i++) {
        if (this.nav[i].to == this.$route.path) {
          this.nav[i].active = true;
        } else if (this.nav[3].text.indexOf(this.$route.path) != -1) {
          this.nav[3].active = true;
        } else if (this.nav[4].text.indexOf(this.$route.path) != -1) {
          this.nav[4].active = true;
        } else if (this.nav[5].text.indexOf(this.$route.path) != -1) {
          this.nav[5].active = true;
        }
      }
    }

    // this.getmsg();
    this.getinfo();
    this.getmsg();
  },
  // watch:{
  //   value(msg){ // 实时监听数据变化
  //    this.wat_fun(val)
  //  }
  // },
  mounted() {
    // this.fetchData()

    // console.log(this.$route.path);
    this.getlogin();
    this.getLog();
    this.getBannner();
  },
  components: {
    Login,
  },
  methods: {
    //1-首页顶部 2-首页左侧 3-首页中部 4-热点动态 5-创新课堂
    getBannner() {
      let that = this;
      this.$axios
        .post(
          "banner/info",
          that.$qs.stringify({
            banner_id: "1",
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.imgBasic = res.data.data.list[0].imgurl;
            this.$forceUpdate();
          }
        });
      this.$axios
        .post(
          "banner/info",
          that.$qs.stringify({
            banner_id: "5",
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.imgClass = res.data.data.list[0].imgurl;
            this.$forceUpdate();
          }
        });
    },

    getLog() {
      this.$axios.post("log/visitnums_show").then((res) => {
        if (res.data.code == 10000) {
          this.logNum.todaylogin += res.data.data.todayvisits * 1;
          this.logNum.totallogin += res.data.data.totalvisits * 1;
        }
      });
    },
    getlogin() {
      this.$axios.post("log/login").then((res) => {
        if (res.data.code == 10000) {
          this.logNum.todaylogin += res.data.data.todaylogin * 1;
          this.logNum.totallogin += res.data.data.totallogin * 1;
        }
      });
    },
    getmsg() {
      this.$axios
        .post(
          "message/index?token=" + sessionStorage.getItem("token"),
          this.$qs.stringify({
            type: this.type == 2 ? 0 : this.type == 0 ? 1 : "",
            status: 0,
          })
        )
        .then((res) => {
          var num = 0;
          if (res.data.code == 10000) {
            res.data.data.list.forEach((val) => {
              if (val.status == 0) {
                num += 1;
              }
            });

            this.msg = num;
          }
        });
    },
    toMsg(type) {
      switch (type) {
        case "0":
          this.$router.replace("/MessageCenter");
          break;
        case "1":
          this.$router.replace("/Message");
          break;
        case "2":
          this.$router.replace("/Structure");
          break;
      }
      console.log(type);
    },
    getinfo() {
      var userinfo = sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(userinfo);
      var token = sessionStorage.getItem("token");
      if (token) {
        if (token.split("-")[0] == "user") {
          if (userinfo.Type == 1) {
            sessionStorage.setItem("type", 0);

            // this.$router.replace("/MessageCenter")
          } else {
            sessionStorage.setItem("type", 3);
            // this.$router.replace("/Bgreview");
          }
        } else {
          if (userinfo.Rank == 0) {
            sessionStorage.setItem("type", 2);
            // this.$router.replace("/Structure");
          } else {
            sessionStorage.setItem("type", 1);
            // this.$router.replace("/Message");
          }
        }
        this.type = sessionStorage.getItem("type");
      }
    },
    toBack() {
      // 跳转后台
      // console.log(sessionStorage.getItem("userinfo"),111)
      var userinfo = sessionStorage.getItem("userinfo");
      console.log(userinfo);
      userinfo = JSON.parse(userinfo);
      var token = sessionStorage.getItem("token");
      if (token.split("-")[0] == "user") {
        if (userinfo.Type == 1) {
          if (
            JSON.parse(sessionStorage.getItem("userinfo")).Phone == 16666666666
          ) {
            sessionStorage.setItem("type", 5);
            this.$router.replace("/Announcement");
          } else {
            sessionStorage.setItem("type", 0);
            this.$router.replace("/Personage");
          }
          // this.$router.replace("/Bgmyproject")
        } else {
          sessionStorage.setItem("type", 3);
          this.$router.replace("/Bgreview");
        }
      } else {
        if (userinfo.Rank == 0) {
          sessionStorage.setItem("type", 2);
          this.$router.replace("/Statistics");
        } else {
          sessionStorage.setItem("type", 1);
          this.$router.replace("/Bgjurisdiction");
        }
      }
    },
    to(e) {
      if (e == 6) {
        if (sessionStorage.getItem("token")) {
          if (this.nav[e].to != this.$route.path && this.nav[e].to != "") {
            this.$router.replace(this.nav[e].to);
          }
        } else {
          this.$message({
            type: "warning",
            message: "请先登录",
          });
          this.isLogin = true;
        }
      } else {
        if (this.nav[e].to != this.$route.path && this.nav[e].to != "") {
          this.$router.replace(this.nav[e].to);
        }
      }
      // if(e=)
    },
    goRegister() {
      if (this.$route.path != "/Register") this.$router.push("/Register");
    },
    openLogin() {
      // console.log(1);
      this.isLogin = true;
    },
    outLogin() {
      let that = this;
      this.$confirm("是否退出当前账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("login/logout?token=" + sessionStorage.getItem("token"))
            .then((res) => {
              if (res.data.code == 10000) {
                Vue.prototype.$uName = "";
                // sessionStorage.clear();
                sessionStorage.removeItem("name");
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("userinfo");
                sessionStorage.removeItem("scroll");
                that.$message({
                  type: "success",
                  message: "退出成功!",
                });
                that.$router.push("Index");
                that.reload();
              } else {
                Vue.prototype.$uName = "";
                // sessionStorage.clear();
                sessionStorage.removeItem("name");
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("userinfo");
                sessionStorage.removeItem("scroll");
                that.$message({
                  type: "success",
                  message: "退出成功!",
                });
                that.$router.push("Index");
                that.reload();
              }
            });
        })
        .catch(() => {});
    },
    openL(e) {
      console.log(e);
      this.isLogin = false;
      if (!e) {
        this.$alert("应网络安全管理部门通知要求，需要您立即修改密码!", "提示", {
          confirmButtonText: "确定",
          callback: () => {
            var userinfo = sessionStorage.getItem("userinfo");
            console.log(userinfo);
            userinfo = JSON.parse(userinfo);
            var token = sessionStorage.getItem("token");
            if (token.split("-")[0] == "user") {
              if (userinfo.Type == 1) {
                if (
                  JSON.parse(sessionStorage.getItem("userinfo")).Phone ==
                  16666666666
                ) {
                  sessionStorage.setItem("type", 5);
                  this.$router.replace("/Announcement");
                } else {
                  sessionStorage.setItem("type", 0);
                  this.$router.replace("/Personage");
                }
                // this.$router.replace("/Bgmyproject")
              } else {
                sessionStorage.setItem("type", 3);
                this.$router.replace("/ExpertPim");
              }
            } else {
              if (userinfo.Rank == 0) {
                sessionStorage.setItem("type", 2);
                this.$router.replace("/Statistics");
              } else {
                sessionStorage.setItem("type", 1);
                this.$router.replace("/Information");
              }
            }
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
#Head {
  position: relative;
  height: 4.6rem;

  .HTop {
    width: 100%;
    position: relative;

    .message {
      display: inline-block;
      position: absolute;
      top: 0.21rem;
      left: 17.12rem;
      width: 0.21rem;
      height: 0.21rem;
      background: rgba(251, 30, 30, 1);
      border-radius: 50%;
      text-align: center;
      line-height: 0.2rem;
      font-size: 0.12rem;
      color: white;
      // margin: 0 0.25rem 0 0.1rem;
      z-index: 66;
      cursor: pointer;
    }

    .Logo {
      position: relative;
      width: 6rem;
      left: 1.7rem;
      top: 0.55rem;
      display: block;
    }

    > .nav {
      position: relative;
      left: 0;
      bottom: 0;
      width: 100%;
      min-width: 1000px;

      img {
        width: 100%;
        display: block;
      }

      .nav_main {
        position: absolute;
        bottom: 0;
        right: 1.35rem;

        ul {
          list-style: none;
          display: flex;
          font-size: 0.23rem;

          li {
            height: 0.88rem;
            line-height: 0.88rem;
            display: flex;
            color: #ffffff;

            p {
              display: block;
              height: 100%;
              padding: 0 0.15rem;
              text-decoration: none;
              color: #ffffff;
              font-weight: 500;
              cursor: pointer;

              &.active {
                border-bottom: 0.03rem solid #f9930f;
                color: #f9930f;
              }

              &:hover {
                color: #f9930f;
              }
            }
          }
        }
      }
    }

    .login {
      ul {
        min-width: 2.5rem;
        display: flex;

        align-items: center;
        justify-content: space-between;

        li {
          font-size: 0.16rem;
          color: #797979;
          margin-right: 0.2rem;

          span {
            color: #2f7dc9;
          }
        }
      }

      display: flex;
      // width: 3rem;
      position: absolute;
      font-size: 0.16rem;
      top: 0.1rem;
      right: 1.35rem;

      div {
        padding: 0.05rem 0.05rem;
        display: flex;
        align-items: center;
        border: 0.01rem solid #e3e3e3;
        color: #2f7dc9;
        // justify-content: space-between;
        cursor: pointer;

        img {
          margin-right: 0.05rem;
          width: 0.2rem;
        }

        .in {
          border: 0;
        }

        .sb {
          padding-right: 0.3rem;
        }
      }

      div:not(:last-child) {
        border-right: 0;
      }
    }
  }

  .HImg {
    width: 100%;
    min-width: 1000px;
    padding: 0.4rem 1.35rem 0;

    img {
      width: 100%;
      height: 2.55rem;
      display: block;
    }
  }
}
</style>
